import React from "react";
import "./Partners.css";
import Banner from "../../assests/slip-icon (4).png";
import Utility_Banner from "../../assests/Component 4.png";
import Dark_Banner from "../../assests/Frame 186399 (1).png";
import { Link } from "react-router-dom";

import VFDBank from "../../assests/vfd_bank.png";
import SudoAfrica from "../../assests/sudo_africa.png";
import Safehaven from "../../assests/safehaven.png";
import Ercas from "../../assests/ercas.png";
import Datahouse from "../../assests/datahouse.png";
import Providus from "../../assests/providus.png";
import Bluesalt from "../../assests/bluesalt.svg";

const partners = [
  { img: VFDBank, name: "VFD Bank" },
  { img: SudoAfrica, name: "Sudo Africa" },
  { img: Safehaven, name: "Safehaven" },
  { img: Ercas, name: "Ercas" },
  { img: Datahouse, name: "Datahouse" },
  { img: Providus, name: "Providus Bank" },
  { img: Bluesalt, name: "Bluesalt" },
];

const Partners = () => {
  return (
    <div className="partners">
      <div className="partners-header">
        <span className="partners-badge">Partners</span>
        <h2>Our Trusted Partners</h2>
        <p>
          Backed by industry leaders who trust <span>SendCheap</span> to power
          secure, seamless payments.
        </p>
      </div>

      {/* Auto-scrolling infinite carousel */}
      <div className="partners-carousel-wrapper">
        <div className="partners-fade-left"></div>
        <div className="partners-fade-right"></div>
        <div className="partners-track">
          {[...partners, ...partners].map((partner, i) => (
            <div className="partner-logo-card" key={i}>
              <img src={partner.img} alt={partner.name} />
              <span className="partner-name">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="partner-features">
        <div className="banner">
          <img src={Banner} alt="" />
        </div>
        <div className="banner">
          <img src={Utility_Banner} alt="" />
        </div>
        <div className="banner">
          <Link to="/products">
            <img src={Dark_Banner} alt="" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Partners;
